import * as React from 'react';
import { Button as ShadcnButton, buttonVariants } from './Button';

type ButtonVariant = 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost' | 'link' | 'primary' | 'tennis';

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading?: boolean;
  children: React.ReactNode;
  variant?: ButtonVariant;
  size?: 'default' | 'sm' | 'lg' | 'icon';
  /** When true, render as the child element (e.g. `Link`) with button styles. */
  asChild?: boolean;
}

const ButtonExtended = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = 'default', size = 'default', isLoading = false, disabled, children, asChild = false, ...props }, ref) => {
    // Map old 'primary' and 'tennis' variants to shadcn's 'default' variant
    const mappedVariant = (
      variant === 'primary' || variant === 'tennis' ? 'default' : variant
    ) as 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost' | 'link' | undefined;

    return (
      <ShadcnButton
        variant={mappedVariant || 'default'}
        size={size as 'default' | 'sm' | 'lg' | 'icon'}
        className={className}
        disabled={disabled || isLoading}
        ref={ref}
        asChild={asChild}
        {...(props as React.ButtonHTMLAttributes<HTMLButtonElement>)}
      >
        {asChild ? (
          children
        ) : (
          <>
            {isLoading && (
              <span className="mr-2 inline-block h-4 w-4 animate-spin">⌛</span>
            )}
            {children}
          </>
        )}
      </ShadcnButton>
    );
  }
);

ButtonExtended.displayName = 'Button';

export { ButtonExtended as Button, buttonVariants };
